import { ConfigService } from "./../../services/config.service";
import { MatDialog } from "@angular/material/dialog";
import { GridsterService } from "./../../services/gridster.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { CompanyList } from "src/app/models/company-list";
import { AccountService } from "src/app/services/account.service";
import { environment } from "src/environments/environment";
import { NgZone, OnDestroy } from "@angular/core";
import { MatSelectChange } from "@angular/material/select";
import { fromEvent, merge, Subscription } from "rxjs";
import { debounceTime, filter } from "rxjs/operators";
import { MarketDepthAsksComponent } from "src/app/components/market-depth-asks/market-depth-asks.component";
import { MarketDepthBidsComponent } from "src/app/components/market-depth-bids/market-depth-bids.component";
import { MarketDepthComponent } from "src/app/components/market-depth/market-depth.component";
import { MarketTradesComponent } from "src/app/components/market-trades/market-trades.component";
import { MarketWatchTableComponent } from "src/app/components/market-watch-table/market-watch-table.component";
import { NewsComponent } from "src/app/components/news/news.component";
import { TradesComponent } from "src/app/components/trades/trades.component";
import { KtdGridLayout, KtdGridLayoutItem } from "./grid.definitions";
import {
  KtdGridComponent,
  ktdTrackById,
  KtdDragStart,
  KtdResizeStart,
  KtdDragEnd,
  KtdResizeEnd,
} from "@katoid/angular-grid-layout";
import { HistoricalComponent } from "src/app/components/historical/historical.component";
import { UrlConstants } from "src/app/models/urlConstants";

@Component({
  selector: "app-home",
  templateUrl: "./home-new.component.html",
  styleUrls: ["./home-new.component.scss"],
})
export class HomeNewComponent implements OnInit {
  isCompaniesLoading: boolean;
  selectedCompanySymbol: any;
  @ViewChildren("MWT") components: QueryList<any>;
  companies: CompanyList[];

  records = [];
  toggleBool = false;
  selectedEgx: CompanyList;

  companiesUpdates: any = [];

  @ViewChild(KtdGridComponent, { static: true }) grid: KtdGridComponent;
  trackById = ktdTrackById;

  cols = 24;
  rowHeight = 60;
  compactType: "vertical";

  layout: KtdGridLayout = [
    {
      w: 10,
      h: 8,
      y: 0,
      x: 0,
      id: "market-watch",
    },
    {
      w: 5,
      h: 4,
      y: 0,
      x: 15,
      id: "news",
    },
    {
      w: 4,
      h: 4,
      y: 8,
      x: 10,
      id: "trades",
    },
    {
      w: 5,
      h: 4,
      y: 4,
      x: 10,
      id: "market-depth",
    },
    {
      w: 3,
      h: 4,
      y: 8,
      x: 17,
      id: "depth-asks",
    },
    {
      w: 3,
      h: 4,
      y: 8,
      x: 14,
      id: "depth-bids",
    },
    {
      w: 5,
      h: 4,
      y: 0,
      x: 10,
      id: "market-trades",
    },
    {
      w: 5,
      h: 4,
      y: 4,
      x: 15,
      id: "historical",
    },
  ];
  transitions: { name: string; value: string }[] = [
    {
      name: "ease",
      value: "transform 500ms ease, width 500ms ease, height 500ms ease",
    },
    {
      name: "ease-out",
      value:
        "transform 500ms ease-out, width 500ms ease-out, height 500ms ease-out",
    },
    {
      name: "linear",
      value: "transform 500ms linear, width 500ms linear, height 500ms linear",
    },
    {
      name: "overflowing",
      value:
        "transform 500ms cubic-bezier(.28,.49,.79,1.35), width 500ms cubic-bezier(.28,.49,.79,1.35), height 500ms cubic-bezier(.28,.49,.79,1.35)",
    },
    {
      name: "fast",
      value: "transform 200ms ease, width 200ms linear, height 200ms linear",
    },
    {
      name: "slow-motion",
      value:
        "transform 1000ms linear, width 1000ms linear, height 1000ms linear",
    },
    { name: "transform-only", value: "transform 500ms ease" },
  ];
  currentTransition: string = this.transitions[1].value;

  dragStartThreshold = 0;
  disableDrag = false;
  disableResize = false;
  disableRemove = false;
  autoResize = false;
  preventCollision = false;
  isDragging = false;
  isResizing = false;
  resizeSubscription: Subscription;

  constructor(
    private http: HttpClient,
    private accService: AccountService,
    public gridService: GridsterService
  ) {
    this.fetchTodayMarketWatch();
  }

  ngOnInit() {
    this.resizeSubscription = merge(
      fromEvent(window, "resize"),
      fromEvent(window, "orientationchange")
    )
      .pipe(
        debounceTime(50),
        filter(() => this.autoResize)
      )
      .subscribe(() => {
        this.grid.resize();
      });
  }

  ngOnDestroy() {
    this.resizeSubscription.unsubscribe();
  }

  onDragStarted(event: KtdDragStart) {
    this.isDragging = true;
  }

  onResizeStarted(event: KtdResizeStart) {
    this.isResizing = true;
  }

  onDragEnded(event: KtdDragEnd) {
    this.isDragging = false;
  }

  onResizeEnded(event: KtdResizeEnd) {
    this.isResizing = false;
  }

  onLayoutUpdated(layout: KtdGridLayout) {
    this.layout = layout;
  }

  onCompactTypeChange(change: MatSelectChange) {
    this.compactType = change.value;
  }

  onTransitionChange(change: MatSelectChange) {
    this.currentTransition = change.value;
  }

  onDisableDragChange(checked: boolean) {
    this.disableDrag = checked;
  }

  onDisableResizeChange(checked: boolean) {
    this.disableResize = checked;
  }

  onDisableRemoveChange(checked: boolean) {
    this.disableRemove = checked;
  }

  onAutoResizeChange(checked: boolean) {
    this.autoResize = checked;
  }

  onPreventCollisionChange(checked: boolean) {
    this.preventCollision = checked;
  }

  onColsChange(event: Event) {
    this.cols = parseInt((event.target as HTMLInputElement).value, 10);
  }

  onRowHeightChange(event: Event) {
    this.rowHeight = parseInt((event.target as HTMLInputElement).value, 10);
  }

  onDragStartThresholdChange(event: Event) {
    this.dragStartThreshold = parseInt(
      (event.target as HTMLInputElement).value,
      10
    );
  }

  /** Adds a grid item to the layout */
  // addItemToLayout() {
  //   const maxId = this.layout.reduce(
  //     (acc, cur) => Math.max(acc, parseInt(cur.id, 10)),
  //     -1
  //   );
  //   const nextId = maxId + 1;

  //   const newLayoutItem: KtdGridLayoutItem = {
  //     id: nextId.toString(),
  //     x: 0,
  //     y: 0,
  //     w: 2,
  //     h: 2,
  //   };

  //   // Important: Don't mutate the array, create new instance. This way notifies the Grid component that the layout has changed.
  //   this.layout = [newLayoutItem, ...this.layout];
  // }

  /**
   * Fired when a mousedown happens on the remove grid item button.
   * Stops the event from propagating an causing the drag to start.
   * We don't want to drag when mousedown is fired on remove icon button.
   */
  stopEventPropagation(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  // /** Removes the item from the layout */
  // removeItem(id: string) {
  //   // Important: Don't mutate the array. Let Angular know that the layout has changed creating a new reference.
  //   this.layout = ktdArrayRemoveItem(this.layout, item => item.id === id);
  // }

  //////////////////////////////////////////////////
  credentialsSearchFilter(event: any) {
    const val = event.target.value.toLowerCase();

    if (val != "") {
      this.toggleBool = true;
    } else {
      this.toggleBool = false;
    }

    this.records = this.companies.filter(function (d) {
      return d.ENG_NAME?.toLowerCase().includes(val);
    });
  }

  WindowResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  }

  get(comp) {
    switch (comp) {
      case "market-watch":
        return MarketWatchTableComponent;
      case "news":
        return NewsComponent;
      case "trades":
        return TradesComponent;
      case "depth-asks":
        return MarketDepthAsksComponent;
      case "depth-bids":
        return MarketDepthBidsComponent;
      case "market-depth":
        return MarketDepthComponent;
      case "market-trades":
        return MarketTradesComponent;
      case "historical":
        return HistoricalComponent;
      case "bids":
        return MarketDepthBidsComponent;
      case "asks":
        return MarketDepthAsksComponent;
    }
  }

  ngAfterViewInit() {
    this.components.first.componentRef.instance.fireFunction = (symbol) => {
      this.selectedCompanySymbol = symbol;
    };
    this.components.first.componentRef.instance.addWidget = (
      name,
      companyData
    ) => {
      const newLayoutItem: KtdGridLayoutItem = {
        id: name,
        x: 20,
        y: 20,
        w: 5,
        h: 5,
        symbolCode: companyData.symbol,
        reuters: companyData.reuters,
        companyName: companyData.name,
      };

      // Important: Don't mutate the array, create new instance. This way notifies the Grid component that the layout has changed.
      this.layout = [newLayoutItem, ...this.layout];

      // this.layout.push({
      //   cols: 4,
      //   rows: 4,
      //   y: 2,
      //   x: 4,
      //   dragEnabled: true,
      //   resizeEnabled: true,
      //   name: name,
      //   symbolCode: companyData.symbol,
      //   reuters: companyData.reuters,
      //   companyName: companyData.name,
      // });
    };
  }

  removeItem(id: string): void {
    // setTimeout(() => {
    //   $event.preventDefault();
    //   $event.stopPropagation();
    //   this.dashboard.splice(this.dashboard.indexOf(item), 1);
    //   this.gridService.saveGrid(this.dashboard);
    // }, 0);
    this.layout = this.ktdArrayRemoveItem(
      this.layout,
      (item) => item.id === id
    );
  }

  ktdArrayRemoveItem<T>(array: T[], condition: (item: T) => boolean) {
    const arrayCopy = [...array];
    const index = array.findIndex((item) => condition(item));
    if (index > -1) {
      arrayCopy.splice(index, 1);
    }
    return arrayCopy;
  }

  fetchTodayMarketWatch() {
    this.isCompaniesLoading = true;
    this.companies = null;
    this.http
      .get(`${UrlConstants.feedUrl}/api/Feed/GetTodayMarketWatch`)
      .subscribe((res) => {
        this.isCompaniesLoading = false;
        this.companies = res as CompanyList[];
        this.switchEgx("EGX30");
        this.WindowResize();
      });
  }

  switchEgx(egx) {
    this.selectedEgx = this.companies.filter((res) => {
      return res.Reuters == egx;
    })[0];
  }

  onSymbolUpdate(newSymbol) {
    this.selectedCompanySymbol = newSymbol;
  }

  selectCompany(symbolCode) {
    this.selectedCompanySymbol = symbolCode;
  }
}
